"use client";
import { useState, useContext } from "react";
import { useRouter } from "next/navigation";
import MaxWidthWrapper from "./MaxWidthWrapper";
import { loginWordpress } from "../services/wordpress";
import FileMaker from "@/components/FileMaker";
import JWTContext from "@/components/JWTProvider";

const LoginForm = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  const { JWT } = useContext(JWTContext); // ✅ use FileMaker auth token

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!username || !password) {
      setError("Both fields are required.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      // 1️⃣ Login to WordPress
      const data = await loginWordpress(username, password);
      sessionStorage.setItem("userData", JSON.stringify(data));

      // 2️⃣ Get CMS ID from WordPress user (assuming it’s stored in data.cms_id or similar)
      const cmsId = data?.cms_id || data?.cmsId;
      console.log("Retrieved CMS ID from WordPress:", cmsId);

      // 3️⃣ If JWT + CMS ID available, fetch Board Meeting info
      let policyBoardMtgId: string = "";
      let policyIdeaId: string = "";
      let isBoard: string = "";

      if (JWT && cmsId) {
        try {
          const fileMaker = new FileMaker(JWT);
          const meetingData = await fileMaker.getBoardMtgId(cmsId);
          const userData = await fileMaker.findUserByCmsId(cmsId);
          if (meetingData) {
              policyBoardMtgId = meetingData["Policy Board Mtg ID"]?.toString() || "";
              policyIdeaId = meetingData["Policy Idea ID"]?.toString() || "";
            }

            if (userData && userData.usertype) {
              isBoard = userData.usertype.toString();
            }
        } catch (fmError) {
          console.error("Error fetching meeting data from FileMaker:", fmError);
        }
      }


      
      // 4️⃣ Save Board Meeting ID in sessionStorage
      sessionStorage.setItem("policyBoardMtgId", policyBoardMtgId ?? "");
      sessionStorage.setItem("isItBoard", isBoard ?? "");
      console.log("Stored Policy Board Mtg ID:", policyBoardMtgId ?? "");

      // 5️⃣ Redirect logic
      const policyToken = sessionStorage.getItem("policyToken");
      console.log("Retrieved policy token from sessionStorage:", policyToken);

      if (policyToken) {
        console.log("Policy token found, redirecting:", `/t/${policyToken}`);
        router.push(`/t/${policyToken}`);
      } else{
        // Default fallback
        console.log("No policy token found, redirecting to home");
        router.push("/");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto flex items-center justify-center min-h-screen">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
        <div className="text-center mb-6">
          <img
            src="https://www.cms.org/wp-content/uploads/2025/02/central-line-1.png"
            alt="Logo"
            className="w-100"
          />
        </div>
        <h2 className="text-2xl font-semibold text-center mb-6">Sign In</h2>

        <div className="flex flex-col border border-gray-300 p-4 rounded mb-4 bg-gray-100 mt-5">
          <form onSubmit={handleSubmit}>
            {error && <p className="text-red-500">{error}</p>}

            <div className="flex flex-col gap-5">
              <div className="sm:col-span-4">
                <label htmlFor="username" className="block text-sm font-medium text-gray-900">
                  Username:
                </label>
                <input
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  className="w-full border rounded-md p-2 text-gray-900"
                />
              </div>

              <div className="sm:col-span-4">
                <label htmlFor="password" className="block text-sm font-medium text-gray-900">
                  Password:
                </label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="w-full border rounded-md p-2 text-gray-900"
                />
              </div>
            </div>

            <button
              type="submit"
              className="mt-5 w-full bg-orange-300 hover:bg-orange-400 text-white font-bold py-2 px-4 rounded"
              disabled={loading}
            >
              {loading ? "Processing..." : "Login"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
